import React, { useState } from "react";
import { MoneyCard } from "Components/shared/cards/MoneyCard";
import Text from "Components/shared/text";
import { TodoList } from "./TodoList";
import styles from "./container.module.css";
import { TransferTransaction } from "./TransferTransaction";
import { images } from "assets";
import Hidden from "Components/shared/hidden";
import { useEffect } from "react";
import { Storage } from "utils/clientStorage";
import { MoneyCards } from "Screens/transfer";
import { useGetWalletBalance } from "services/walletService";
import { useQueryClient } from "react-query";
import { convertToCurrency } from "utils/stringServices";

export const DashboardLeft = ({ transaction, handleClick }) => {
  const [toDoCacl, setTodoCalc] = useState(null);
  const [firstName, setFirstName] = useState(null);

  const [transactions, setTransaction] = useState("345");
  const { data: walletBal } = useGetWalletBalance();
  const queryClient = useQueryClient();
  const onRefreshHandler = (cb) => {
    queryClient.invalidateQueries("wallet-balance");
    setTimeout(() => {
      cb?.();
    }, 3000);
  };

  useEffect(() => {
    const calc = Storage.getItem("TODO_SUM");
    const profile = Storage.getItem("PROFILE");
    setTodoCalc(calc);
    setFirstName(profile.firstName);
    console.log(profile.firstName);
  }, [toDoCacl]);
  return (
    <Text tag="div">
      <Hidden smUp>
        <Text tag="div" style={{ padding: "1.2rem 0" }}>
          <Text tag="div" className={styles.header}>
            <img
              src={images.profileImage}
              alt="PROFILE"
              style={{ width: "40px", height: "40px", borderRadius: "10%" }}
            />
            <Text tag="div">
              <Text style={{ fontWeight: 600 }} variant="md2">
                Hi {firstName},
              </Text>
              <Text variant="xs" style={{ color: "var(--disabled-color)" }}>
                Welcome back on baord
              </Text>
            </Text>
          </Text>
        </Text>
      </Hidden>
      {/* <MoneyCards /> */}
      <>
        <Hidden mdUp>
          <div className={styles.cards}>
            <MoneyCard
              background="#21c06b1a"
              symbol="₦"
              currency="Naira Balance"
              amount={convertToCurrency(walletBal?.data?.ngn || 0)}
              variant="lg"
              onRefresh={onRefreshHandler}
            />
            <MoneyCard
              background="#0169FF1a"
              symbol="$"
              currency="Dollar Balance"
              amount={convertToCurrency(walletBal?.data?.usd || 0)}
              variant="lg"
              onRefresh={onRefreshHandler}
            />
            <MoneyCard
              background="#E2E8F0"
              symbol="€"
              currency="Euro Balance"
              amount={convertToCurrency(walletBal?.data?.eur || 0)}
              variant="lg"
              onRefresh={onRefreshHandler}
            />
          </div>
        </Hidden>
        <Hidden smDown>
          <div className={styles.cards}>
            <MoneyCard
              background="#21c06b1a"
              symbol="₦"
              currency="Naira Balance"
              amount={convertToCurrency(walletBal?.data?.ngn || 0)}
              variant="sm"
              onRefresh={onRefreshHandler}
            />
            <MoneyCard
              background="#0169FF1a"
              symbol="$"
              currency="Dollar Balance"
              amount={convertToCurrency(walletBal?.data?.usd || 0)}
              variant="sm"
              onRefresh={onRefreshHandler}
            />
            <MoneyCard
              background="#E2E8F0"
              symbol="€"
              currency="Euro Balance"
              amount={convertToCurrency(walletBal?.data?.eur || 0)}
              variant="sm"
              onRefresh={onRefreshHandler}
            />
          </div>
        </Hidden>
      </>
      {toDoCacl === 100 ? (
        <TransferTransaction handleClick={handleClick} />
      ) : (
        <TodoList handleClick={handleClick} />
      )}
    </Text>
  );
};
